<ion-card class="total-price-info">
	@if (showTable) {
		<ion-row>
			<ion-col>
				<div class="title">{{ 'statistics.bay' | translate }}</div>
			</ion-col>
			<ion-col>
				<div class="title monospace align-self-end">
					{{ paySessionStatistics?.table }}
				</div>
			</ion-col>
		</ion-row>
	}
	@if (showChecks) {
		@for (check of paySessionStatistics?.checkIds; track check) {
			<ion-row>
				<ion-col>
					<div class="title">{{ 'statistics.checkId' | translate }}</div>
				</ion-col>
				<ion-col>
					<div class="title monospace align-self-end">
						{{ check }}
					</div>
				</ion-col>
			</ion-row>
		}
	}
	@if (showPaid) {
		<ion-row>
			<ion-col>
				<div class="title">{{ 'statistics.alreadyPaid' | translate }}</div>
			</ion-col>
			<ion-col>
				<div class="title monospace align-self-end">
					{{ formattedPaid }}
				</div>
			</ion-col>
		</ion-row>
	}
	@if (showDues) {
		<ion-row>
			<ion-col>
				<div class="title">{{ 'statistics.stillToPay' | translate }}</div>
			</ion-col>
			<ion-col>
				<div class="title monospace align-self-end">
					{{ formattedToPayAmount }}
				</div>
			</ion-col>
		</ion-row>
	}
	@if (showSelected) {
		<ion-row>
			<ion-col>
				<div class="title">
					{{ 'statistics.selectedItems' | translate }} (<span>{{ paySessionStatistics?.selectedProductsCount }}</span> &nbsp;{{
						'statistics.items' | translate
					}})
				</div>
				@if (paySessionStatistics?.selectedDiscount) {
					<div class="sub-title">{{ 'statistics.discount' | translate }}</div>
				}
			</ion-col>
			<ion-col>
				<div class="title monospace align-self-end">
					{{ formattedSelected }}
				</div>
				@if (paySessionStatistics?.selectedDiscount) {
					<div class="sub-title monospace align-self-end">
						{{ formattedSelectedDiscount }}
					</div>
				}
			</ion-col>
		</ion-row>
		@for (tax of paySessionStatistics?.selectedTax; track tax) {
			<ion-row class="tax-row">
				<ion-col>
					<div class="sub-title">{{ tax.name }}</div>
				</ion-col>
				<ion-col>
					<div class="sub-title monospace align-self-end">
						{{ format(tax.total) }}
					</div>
				</ion-col>
			</ion-row>
		}
	}
	@if (showTips && paySessionStatistics?.tipsValue) {
		<ion-row>
			<ion-col>
				<div class="title">{{ 'statistics.tip' | translate }}</div>
			</ion-col>
			<ion-col>
				<div class="title monospace align-self-end">
					{{ formattedTips }}
				</div>
			</ion-col>
		</ion-row>
	}
	@if (showTotal) {
		<ion-row>
			<ion-col>
				<div class="title">
					{{ 'statistics.total' | translate }} (<span>{{ paySessionStatistics?.totalProducts }}</span> &nbsp;{{
						'statistics.items' | translate
					}})
				</div>

				@if (paySessionStatistics?.totalDiscount) {
					<div class="sub-title">{{ 'statistics.totalDiscount' | translate }}</div>
				}
			</ion-col>
			<ion-col>
				<div class="title monospace align-self-end">
					{{ formattedTotal }}
				</div>
				@if (paySessionStatistics?.totalDiscount) {
					<div class="sub-title monospace align-self-end">
						{{ formattedTotalDiscount }}
					</div>
				}
			</ion-col>
		</ion-row>
		@if (remainingAmount !== null) {
			<ion-row>
				<ion-col>
					<div class="title" style="color: #ff9800; font-weight: 700">{{ 'statistics.remaining' | translate }}</div>
				</ion-col>
				<ion-col>
					<div class="title monospace align-self-end" style="color: #ff9800; font-weight: 700">
						{{ formattedRemainingAmount }}
					</div>
				</ion-col>
			</ion-row>
		}
		@for (tax of paySessionStatistics?.combinedPosCheckoutTaxes; track tax) {
			<ion-row class="tax-row">
				<ion-col>
					<div class="sub-title">{{ tax.name }}</div>
				</ion-col>
				<ion-col>
					<div class="sub-title monospace align-self-end">
						{{ format(tax.total) }}
					</div>
				</ion-col>
			</ion-row>
		}
	}
</ion-card>
